angular.module('jv.requisition.linkedIn.controller', [])
.controller('ReqsLinkedInCtrl', ['$scope', 'Reqs', '$timeout',
function ($scope, Reqs, $timeout) {
    $scope.linkedInData = {};
    $scope.showErrorResponse = false;
    $scope.flags.invalidEmail=false;
    $scope.requisitions.linkedRenewModel=false;
    $scope.requisitions.linkedInUpdateModal=false;
    $scope.requisitions.selectedlocation='';
    Reqs.linkedInData(function (response) {
        $scope.linkedInData = response;
    });
    
    /**
     * validation for post to linkedIn
     */
    $scope.validate = function () {
        if (($.trim($scope.requisitions.posterEmail) === '') ||
            !$scope.role || !$scope.jobType || !$scope.expCode ||
            $.isEmptyObject($scope.industries) || $.isEmptyObject($scope.jobFunctions)
        ) {
            $scope.flags.valError = true;
            return;
        }
        if ($scope.showPostalCode($scope.requisitions.selectedlocations, $scope.requisitions.locations) && !$scope.selectedPostalCode) {
            $scope.flags.valError = true;
            return;
        }

        if (!!$scope.requisitions.posterEmail && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test($scope.requisitions.posterEmail)) {
            $scope.flags.invalidEmail = true;
            return;
        }
        if(window.isLinkedinV2Enabled && !($scope.requisitions.selectedContract && $scope.requisitions.selectedContract!=='')){
            $scope.flags.valError = true;
            return;
        }
        $scope.flags.valError = false;
        $scope.flags.invalidEmail=false;
    };
    
    
    $scope.validateAndPostToLinkedIn = function(liAction){
     $scope.validate();
         if ($scope.flags.invalidEmail || $scope.flags.valError) {
            return;
         }
        Reqs.getLinkedInPremiumJobPostStatus($scope.requisitions.jobDetails.EId, function(statusData){
            for(var counter in statusData){
               if(statusData[counter].contractId===$scope.requisitions.selectedContract
                    && statusData[counter].jobStatus==='IN_PROGRESS'&&statusData[counter].locationEId===$scope.requisitions.selectedlocations){
                        $scope.linkedErrorMessage = i18n['LINKEDIN_UNABLE_TO_POST'];
                        $scope.showErrorResponse = true;
                   return;
               }
            }
            $scope.post(liAction);
        });
     };
     
    /**
     * Method used to post to linkedIn
     */
    $scope.post = function (liAction) {
        $scope.validate();
        if ($scope.flags.invalidEmail || $scope.flags.valError) {
            return;
        }
        var postData = {
            j: $scope.requisitions.jobDetails.EId,
            posterEmail: $scope.requisitions.posterEmail,
            expCode: $scope.expCode,
            role: $scope.role,
            jobType: $scope.jobType,
            loc: $scope.requisitions.selectedlocations,
            zip: $scope.selectedPostalCode,
            contract:$scope.requisitions.selectedContract,
            industries: $scope.industries,
            jobFunctions: $scope.jobFunctions,
            linkedInAction:liAction
        };

        Reqs.postToLinkedIn(postData, $scope.requisitions.jobDetails.EId,
            function (response) {
                if (response.msgError) {
                    if (response.msgError >= 200 && response.msgError <=299) {
                        $scope.cancel();
                        $scope.requisitions.linkedInmodal = false;
                        $scope.requisitions.linkedInUpdateModal=false;
                        $scope.showMsg('JOB_POSTED');
                        $scope.getLinkedInPremiumJobPostStatus();
                    } else if (response.msgError === 412) {
                        $scope.linkedErrorMessage = i18n['LINKEDIN_UNAUTHORIZED'];
                        $scope.showErrorResponse = true;
                    }else {
                        $scope.showErrorResponse = true;
                        var error=response.msgError;
                        var contractId=$scope.requisitions.contracts.premiumJobContracts.length>1?$scope.requisitions.selectedContract:$scope.requisitions.contracts.premiumJobContracts[0].contract;
                        if(error===400||error===404||error===500||error===504||error===401||error===402||error===409){
                           $scope.linkedErrorMessage = i18n['linkedInErrorcode' + error].format(contractId);
                        }else{
                           $scope.linkedErrorMessage = i18n['linkedInErrorcode'].format(contractId);
                        }
                    }
                } else {
                    $scope.linkedErrorMessage = response && response.error_message;
                    $scope.showErrorResponse = true;
                }
            }
        );
    };
    
    $scope.getLinkedInPremiumJobPostStatus = function() {
        Reqs.getLinkedInPremiumJobPostStatus($scope.requisitions.jobDetails.EId  ,function(response) {
            if(response) {
                    $scope.requisitions.linkedinJobPosting = response;
            }
        });
   };

    $scope.showPostalCode = function (selectedLocation, locations) {
        if (selectedLocation && locations) {
            for (var i = 0; i < locations.length; i++) {
                if (locations[i].EId === selectedLocation && !locations[i].postalCode) {
                    return locations[i].remote;
                }
            }
        }
        return false;
    };


    $scope.cancel = function () {
        $scope.requisitions.linkedInmodal = false;
        $scope.requisitions.linkedInUpdateModal=false;
        $scope.requisitions.selectedPosting='select';
        $scope.requisitions.selectedlocations = '';
        $scope.requisitions.selectedContract = '';
        $scope.selectedPostalCode = '';
        $scope.showErrorResponse = false;
        $scope.industries = '';
        $scope.jobFunctions = '';
        $scope.flags.valError = false;
        $scope.flags.invalidEmail = false;
        $scope.role = '';
        $scope.expCode = '';
        $scope.jobType = '';
        $scope.requisitions.selectedlocation='';
        $scope.linkedInData = angular.copy($scope.linkedInData);
        $timeout(function(){
            $('.modal select').trigger('change');
        });
    };
}
]);
